/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  destroyOnCollapse: Boolean,
  disabled: {
    type: Boolean,
    "default": void 0
  },
  expandIcon: {
    type: [Boolean, Function],
    "default": void 0
  },
  header: {
    type: [String, Function]
  },
  headerRightContent: {
    type: [String, Function]
  },
  value: {
    type: [String, Number]
  }
};

export { props as default };
//# sourceMappingURL=collapse-panel-props.js.map
